import React from 'react';
import styled from 'styled-components';
import LicensePlateInput from '../../../components/form/license-plate-input';

const LicensePlate = (props) => (
  <LicensePlateInput {...props} />
);

export default styled(LicensePlate)``;
